import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import { DubAnalytics } from "@/lib/dub";
import { ClerkAnalyticsTracker } from "@/components/ClerkAnalyticsTracker";

// Import main pages eagerly to avoid initial loading state
import Index from './pages/Index';
import NotFound from './pages/NotFound';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Pricing from './pages/Pricing';
import PRDGenerator from './pages/PRDGenerator';

const queryClient = new QueryClient();

// DISABLED: CMP route sync interferes with native Iubenda behavior on mobile
// Iubenda scripts handle their own state management across routes
// function CMPRouteSync() {
//   const location = useLocation();

//   useEffect(() => {
//     iubendaService.ensureListeners();
//     if (import.meta.env.DEV) {
//       // Minimal dev-only trace to confirm coverage
//       console.info("[CMP] ensured listeners on route:", location.pathname);
//     }
//   }, [location.pathname]);

//   return null;
// }

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <ClerkAnalyticsTracker />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/prd-generator" element={<PRDGenerator />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <DubAnalytics />
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
